export default {
  // list
  'container_transport_order_detail.column.orderId': 'orderId',
  'container_transport_order_detail.column.ladingOrderId': 'ladingOrderId',
  'container_transport_order_detail.column.transportOrderId': 'transportOrderId',
  'container_transport_order_detail.column.orderCargoId': 'orderCargoId',
  'container_transport_order_detail.column.orderCargoDetailId': 'orderCargoDetailId',
  'container_transport_order_detail.column.cargoQty': 'cargoQty',
  'container_transport_order_detail.column.cargoWeight': 'cargoWeight',
  'container_transport_order_detail.column.loadingPoint': 'loadingPoint',
  'container_transport_order_detail.column.unloadingPoint': 'unloadingPoint',
  'container_transport_order_detail.column.transportToolName': 'transportToolName',
  'container_transport_order_detail.column.trainNumber': 'trainNumber',
  'container_transport_order_detail.column.startTime': 'startTime',
  'container_transport_order_detail.column.endTime': 'endTime',
  'container_transport_order_detail.column.etdTime': 'etdTime',
  'container_transport_order_detail.column.createBy': 'createBy',
  'container_transport_order_detail.column.updateBy': 'updateBy',
  'container_transport_order_detail.column.createTime': 'createTime',
  'container_transport_order_detail.column.updateTime': 'updateTime',
  'container_transport_order_detail.column.dataSource': 'dataSource',
  'container_transport_order_detail.column.remark': 'remark',
  'container_transport_order_detail.column.status': 'status',
  // edit
  'container_transport_order_detail.edit.title': 'Edit ContainerTransportOrderDetail',
  'container_transport_order_detail.add.title': 'Add ContainerTransportOrderDetail',
  'container_transport_order_detail.edit.success': 'Edit Successful',
  'container_transport_order_detail.add.success': 'Add Successful',
  'container_transport_order_detail.form.orderId.required': 'orderId cannot be null',
  'container_transport_order_detail.form.ladingOrderId.required': 'ladingOrderId cannot be null',
  'container_transport_order_detail.form.transportOrderId.required': 'transportOrderId cannot be null',
  'container_transport_order_detail.form.orderCargoId.required': 'orderCargoId cannot be null',
  'container_transport_order_detail.form.orderCargoDetailId.required': 'orderCargoDetailId cannot be null',
  'container_transport_order_detail.form.cargoQty.required': 'cargoQty cannot be null',
  'container_transport_order_detail.form.cargoWeight.required': 'cargoWeight cannot be null',
  'container_transport_order_detail.form.loadingPoint.required': 'loadingPoint cannot be null',
  'container_transport_order_detail.form.unloadingPoint.required': 'unloadingPoint cannot be null',
  'container_transport_order_detail.form.transportToolName.required': 'transportToolName cannot be null',
  'container_transport_order_detail.form.trainNumber.required': 'trainNumber cannot be null',
  'container_transport_order_detail.form.orderId': 'orderId',
  'container_transport_order_detail.form.orderId.placeholder': 'Enter orderId',
  'container_transport_order_detail.form.ladingOrderId': 'ladingOrderId',
  'container_transport_order_detail.form.ladingOrderId.placeholder': 'Enter ladingOrderId',
  'container_transport_order_detail.form.transportOrderId': 'transportOrderId',
  'container_transport_order_detail.form.transportOrderId.placeholder': 'Enter transportOrderId',
  'container_transport_order_detail.form.orderCargoId': 'orderCargoId',
  'container_transport_order_detail.form.orderCargoId.placeholder': 'Enter orderCargoId',
  'container_transport_order_detail.form.orderCargoDetailId': 'orderCargoDetailId',
  'container_transport_order_detail.form.orderCargoDetailId.placeholder': 'Enter orderCargoDetailId',
  'container_transport_order_detail.form.cargoQty': 'cargoQty',
  'container_transport_order_detail.form.cargoQty.placeholder': 'Enter cargoQty',
  'container_transport_order_detail.form.cargoWeight': 'cargoWeight',
  'container_transport_order_detail.form.cargoWeight.placeholder': 'Enter cargoWeight',
  'container_transport_order_detail.form.loadingPoint': 'loadingPoint',
  'container_transport_order_detail.form.loadingPoint.placeholder': 'Enter loadingPoint',
  'container_transport_order_detail.form.unloadingPoint': 'unloadingPoint',
  'container_transport_order_detail.form.unloadingPoint.placeholder': 'Enter unloadingPoint',
  'container_transport_order_detail.form.transportToolName': 'transportToolName',
  'container_transport_order_detail.form.transportToolName.placeholder': 'Enter transportToolName',
  'container_transport_order_detail.form.trainNumber': 'trainNumber',
  'container_transport_order_detail.form.trainNumber.placeholder': 'Enter trainNumber',
  'container_transport_order_detail.form.startTime': 'startTime',
  'container_transport_order_detail.form.startTime.placeholder': 'Enter startTime',
  'container_transport_order_detail.form.endTime': 'endTime',
  'container_transport_order_detail.form.endTime.placeholder': 'Enter endTime',
  'container_transport_order_detail.form.etdTime': 'etdTime',
  'container_transport_order_detail.form.etdTime.placeholder': 'Enter etdTime',
}
